import { useQuery, gql } from '@apollo/client';
// @ts-expect-error immer intentionally exposes freeze but it's missing from the type definitions https://immerjs.github.io/immer/api/
import { freeze } from 'immer';
import { List, Map as ImmutableMap } from 'immutable';
import memoize from 'transmute/memoize';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
export const FETCH_TIMELINE_FILTERS = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"fetchTimelineFilters\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"subjectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObject\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"subjectId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timeline\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"internalName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"translatedName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"filters\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"selected\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"internalName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroupInternalName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}}]}}]}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "fetchTimelineFilters"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "subjectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObject"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "subjectId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectTypeId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "timeline"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "filterGroups"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "internalName"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "translatedName"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "filters"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "displayName"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "selected"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "internalName"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "filterGroupInternalName"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
export const useFetchTimelineFilters = ({
  subjectId,
  objectTypeOrId
}) => {
  return useQuery(FETCH_TIMELINE_FILTERS, {
    nextFetchPolicy: 'cache-first',
    variables: {
      subjectId: Number(subjectId),
      objectTypeId: normalizeTypeId(objectTypeOrId)
    }
  });
};

/**
 * @param filterGroups groups of filters (Communication, Team Activity, Contact Activity, Updates, Integrations)
 * @returns Immutable Map with internal name of group to the internal names of all possible filters
 * in Immutable Lists in each group
 */
export const getAllFilterGroups = memoize(filterGroups => {
  const allFilterGroups = filterGroups.reduce((acc, filterGroup) => {
    const values = filterGroup['filters'].map(filter => filter.internalName);
    return acc.set(filterGroup.internalName, List(values));
  }, ImmutableMap());
  return allFilterGroups;
});

/**
 * @param filterGroups groups of filters (Communication, Team Activity, Contact Activity, Updates, Integrations)
 * @returns JS object with internal name of group to the internal names of all possible filters
 * in Immutable Lists in each group
 */
export const getAllFilterGroupsJS = filterGroups => {
  const allFilterGroups = filterGroups.reduce((acc, filterGroup) => {
    const values = filterGroup['filters'].map(filter => filter.internalName);
    acc[filterGroup.internalName] = values;
    return acc;
  }, {});
  return freeze(allFilterGroups);
};
const getAllFilterObjects = memoize(filterGroups => {
  return filterGroups.reduce((acc, filterGroup) => {
    acc.push(filterGroup.filters);
    return acc;
  }, []);
});

/**
 * @param filterGroups groups of filters (Communication, Team Activity, Contact Activity, Updates, Integrations)
 * @returns internal names of all possible filters in an Immutable List
 */
export const getAllFilters = memoize(filterGroups => {
  const allFilters = getAllFilterObjects(filterGroups);
  return allFilters.flat().reduce((acc, filter) => {
    return acc.push(filter.internalName);
  }, List());
});

/**
 * @param filterGroups groups of filters (Communication, Team Activity, Contact Activity, Updates, Integrations)
 * @returns internal names of all possible filters in an array
 */
export const getAllFiltersJS = memoize(filterGroups => {
  const allFilters = getAllFilterObjects(filterGroups);
  const allFilterNames = allFilters.flat().reduce((acc, filter) => {
    acc.push(filter.internalName);
    return acc;
  }, []);
  return freeze(allFilterNames);
});

/**
 * @param filterGroups groups of filters (Communication, Team Activity, Contact Activity, Updates)
 * @returns internal names of selected filters in an Immutable List
 */
export const getSelectedFilters = memoize(filterGroups => {
  const allFilters = getAllFilterObjects(filterGroups);
  const selectedFilters = allFilters.flat().reduce((acc, filter) => {
    return filter.selected ? acc.push(filter.internalName) : acc;
  }, List());
  return selectedFilters;
});

/**
 * @param filterGroups groups of filters (Communication, Team Activity, Contact Activity, Updates, Integrations)
 * @returns internal names of all selected filters in an array
 */
export const getSelectedFiltersJS = memoize(filterGroups => {
  const allFilters = getAllFilterObjects(filterGroups);
  const selectedFilters = allFilters.flat().reduce((acc, filter) => {
    if (filter.selected) {
      acc.push(filter.internalName);
    }
    return acc;
  }, []);
  return freeze(selectedFilters);
});